// redux helpers
import { hasAllRoles, hasAnyAndAllRoles, hasAnyRoles, userRoles } from 'utils/currentUserRoles';

// eslint-disable-next-line import/prefer-default-export
export const TOP_NAVIGATION_LINKS = [
  {
    id: 0,
    label: 'Inventory',
    ldfeature: process.env.REACT_APP_LD_INVENTORY,
    route: 'inventory-management',
    subRoutes: [
      {
        id: 1,
        label: 'Inventory Dashboard',
        route: 'inventory-management/inventory-dashboard',
        subRoutes: [
          {
            id: 0,
            label: 'Inventory Projections',
            route: 'inventory-management/inventory-dashboard/projections',
          },
          {
            id: 1,
            label: 'Inventory Reports',
            route: 'inventory-management/inventory-dashboard/reports',
          },
        ],
        userRoles: hasAllRoles([userRoles.INVENTORY_OWNER, userRoles.PRODUCT_OWNERSHIP_VIEW]),
      },
      {
        id: 2,
        label: 'Product Transfer Orders',
        route: 'inventory-management/product-ownership/',
        subRoutes: [
          {
            id: 0,
            label: 'Open Transfer Orders',
            route: 'inventory-management/product-ownership/open',
          },
          {
            id: 1,
            label: 'Advanced Search',
            route: 'inventory-management/product-ownership/search',
          },
        ],
        userRoles: hasAllRoles([userRoles.INVENTORY_OWNER, userRoles.PRODUCT_OWNERSHIP_VIEW]),
      },
      {
        id: 3,
        label: 'Reconsignments',
        route: 'inventory-management/reconsignments/',
        userRoles: hasAllRoles([userRoles.INVENTORY_OWNER, userRoles.PRODUCT_OWNERSHIP_VIEW]),
      },
    ],
    userRoles: hasAllRoles([userRoles.PRODUCT_OWNERSHIP_VIEW]),
  },
  {
    id: 1,
    label: 'Shipping',
    ldfeature: process.env.REACT_APP_LD_SHIPPING,
    route: 'shipping',
    subRoutes: [
      {
        id: 1,
        label: 'Batches',
        route: 'shipping/batches/',
        subRoutes: [
          {
            id: 0,
            label: 'Batches',
            route: 'shipping/batches/batch',
            userRoles: hasAnyRoles([userRoles.SHIPPER]),
          },
          {
            id: 1,
            label: 'Shipments',
            route: 'shipping/batches/shipment',
            userRoles: hasAnyRoles([userRoles.SHIPPER]),
          },
          {
            id: 2,
            label: 'Distributions',
            route: 'shipping/batches/distribution',
            userRoles: hasAnyRoles([userRoles.INVENTORY_OWNER, userRoles.SHIPPER]),
          },
        ],
        userRoles: hasAnyRoles([userRoles.INVENTORY_OWNER, userRoles.SHIPPER]),
      },
      {
        id: 2,
        label: 'Monthly Nominations',
        route: 'shipping/monthly-nominations/',
        subRoutes: [
          {
            id: 0,
            label: 'Nominated',
            route: 'shipping/monthly-nominations/nominated',
            userRoles: hasAllRoles([userRoles.SHIPPER]),
          },
          {
            id: 1,
            label: 'Awarded',
            route: 'shipping/monthly-nominations/awarded',
            userRoles: hasAllRoles([userRoles.SHIPPER]),
          },
          {
            id: 2,
            label: 'Accepted',
            route: 'shipping/monthly-nominations/accepted',
            userRoles: hasAllRoles([userRoles.SHIPPER]),
          },
          {
            id: 3,
            label: 'Rejected',
            route: 'shipping/monthly-nominations/rejected',
            userRoles: hasAllRoles([userRoles.SHIPPER]),
          },
        ],
        userRoles: hasAllRoles([userRoles.SHIPPER]),
      },
    ],
    userRoles: hasAllRoles([userRoles.PRODUCT_SHIPPING_VIEW]),
  },
  {
    id: 2,
    label: 'Loading',
    ldfeature: process.env.REACT_APP_LD_LOADING,
    route: 'loading-management',
    subRoutes: [
      {
        id: 0,
        label: 'Self Authorizations',
        ldfeature: process.env.REACT_APP_LD_SELF_AUTH_LIST_VIEW,
        route: 'loading-management/self-authorizations/list-view/',
        userRoles: hasAllRoles([userRoles.INVENTORY_OWNER, userRoles.PRODUCT_LOADING_VIEW]),
      },
      {
        id: 0.1,
        label: 'Self Authorizations',
        ldelse: process.env.REACT_APP_LD_SELF_AUTH_LIST_VIEW,
        route: 'loading-management/self-authorizations/',
        subRoutes: [
          {
            id: 1,
            label: 'Authorizations by Location',
            route: `loading-management/self-authorizations/location/`,
          },
          {
            id: 2,
            label: 'Authorizations by Product',
            route: `loading-management/self-authorizations/product/`,
          },
        ],
        userRoles: hasAllRoles([userRoles.INVENTORY_OWNER, userRoles.PRODUCT_LOADING_VIEW]),
      },
      {
        id: 1,
        label: 'Supplier Authorizations',
        route: 'loading-management/supplier-authorizations/',
        subRoutes: [
          {
            feature: process.env.REACT_APP_LD_CARRIER_AUTH_LIST_VIEW,
            id: 1,
            label: 'Authorizations by Supplier',
            route: 'loading-management/supplier-authorizations/supplier/',
          },
          {
            feature: process.env.REACT_APP_LD_CARRIER_AUTH_LIST_VIEW,
            id: 2,
            label: 'Authorizations by Location',
            route: 'loading-management/supplier-authorizations/location/',
          },
          {
            feature: process.env.REACT_APP_LD_CARRIER_AUTH_LIST_VIEW,
            id: 3,
            label: 'Authorizations by Product',
            route: 'loading-management/supplier-authorizations/product/',
          },
        ],
        userRoles: hasAllRoles([userRoles.INVENTORY_OWNER, userRoles.PRODUCT_LOADING_VIEW]),
      },
      {
        id: 2,
        label: 'Authorization Sequencing',
        route: 'loading-management/authorization-sequencing/',
        subRoutes: [
          {
            feature: process.env.REACT_APP_LD_AUTHORIZATION_SEQUENCING_FILTERABLE_CONTENT_GRID,
            id: 1,
            label: 'Sequencing by Location',
            route: 'loading-management/authorization-sequencing/location/',
          },
          {
            feature: process.env.REACT_APP_LD_AUTHORIZATION_SEQUENCING_FILTERABLE_CONTENT_GRID,
            id: 2,
            label: 'Sequencing by Product',
            route: 'loading-management/authorization-sequencing/product/',
          },
        ],
        userRoles: hasAllRoles([userRoles.SUPPLIER, userRoles.PRODUCT_LOADING_VIEW]),
      },
      {
        id: 3,
        label: 'My Authorizations',
        route: 'loading-management/my-authorizations/inventory-owner/',
        userRoles: hasAllRoles([userRoles.SUPPLIER, userRoles.PRODUCT_LOADING_VIEW]),
      },
      {
        id: 4,
        label: 'Carrier Authorizations',
        route: 'loading-management/carrier-authorizations/',
        subRoutes: [
          {
            feature: process.env.REACT_APP_LD_CARRIER_AUTH_LIST_VIEW,
            id: 1,
            label: 'Authorizations by Carrier',
            route: 'loading-management/carrier-authorizations/carrier/',
          },
          {
            feature: process.env.REACT_APP_LD_CARRIER_AUTH_LIST_VIEW,
            id: 2,
            label: 'Authorizations by Location',
            route: 'loading-management/carrier-authorizations/location/',
          },
        ],
        userRoles: hasAllRoles([userRoles.SUPPLIER, userRoles.PRODUCT_LOADING_VIEW]),
      },
      {
        id: 5,
        label: 'Customer Authorizations',
        route: 'loading-management/customer-authorizations',
        userRoles: hasAllRoles([userRoles.SUPPLIER, userRoles.PRODUCT_LOADING_VIEW]),
      },
      {
        id: 6,
        label: 'Terminal Information',
        route: 'loading-management/terminal-information/terminal-locator/',
        userRoles: hasAnyAndAllRoles({
          all: [userRoles.PRODUCT_LOADING_VIEW],
          any: [userRoles.INVENTORY_OWNER, userRoles.SUPPLIER],
        }),
      },
      {
        id: 7,
        label: 'Terminal Allocation Loading Percentage',
        route: 'loading-management/terminal-allocation-loading-percentage/',
        userRoles: hasAnyAndAllRoles({
          all: [userRoles.PRODUCT_LOADING_VIEW],
          any: [userRoles.INVENTORY_OWNER, userRoles.SUPPLIER],
        }),
      },
    ],
    userRoles: hasAllRoles([userRoles.PRODUCT_LOADING_VIEW]),
  },
  {
    id: 3,
    label: 'Dispatching',
    ldfeature: process.env.REACT_APP_LD_DISPATCHING,
    route: 'dispatching',
    subRoutes: [
      {
        id: 1,
        label: 'Loads',
        ldfeature: process.env.REACT_APP_LD_DISPATCHING_LOADS,
        route: 'dispatching/loads/',
        subRoutes: [
          {
            id: 0,
            label: 'Loads By Date',
            route: 'dispatching/loads/date',
            userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
          },
          {
            id: 1,
            label: 'Loads By Destination',
            route: 'dispatching/loads/destination',
            userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
          },
          {
            id: 2,
            label: 'Loads By Location',
            route: 'dispatching/loads/location',
            userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
          },
          {
            id: 3,
            label: 'Loads By Driver',
            route: 'dispatching/loads/driver',
            userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
          },
        ],
        userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
      },
      {
        id: 2,
        label: 'Compliance',
        route: 'dispatching/compliance/',
        subRoutes: [
          {
            id: 0,
            label: 'Trailer Status',
            route: 'dispatching/compliance/trailer-status',
            userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
          },
          {
            id: 1,
            label: 'Driver Status',
            route: 'dispatching/compliance/driver-status',
            userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
          },
        ],
        userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
      },
    ],
    userRoles: hasAnyRoles([userRoles.DISPATCHING_VIEW]),
  },
  {
    id: 4,
    label: 'Global',
    ldfeature: process.env.REACT_APP_LD_GLOBAL,
    route: 'global-data',
    subRoutes: [
      {
        id: 1,
        label: 'Points',
        route: 'global-data/points/',
        userRoles: hasAnyRoles([userRoles.USER]),
      },
      {
        id: 2,
        label: 'Products',
        route: 'global-data/products/',
        userRoles: hasAnyRoles([userRoles.USER]),
      },
      {
        id: 3,
        label: 'Destinations',
        route: 'global-data/destinations/',
        userRoles: hasAnyRoles([userRoles.USER]),
      },
    ],
    userRoles: hasAllRoles([userRoles.USER]),
  },
  {
    id: 5,
    label: 'Home',
    route: '',
    userRoles: hasAllRoles([userRoles.USER]),
  },
];
